import React from 'react';

import isNil from 'lodash/isNil';

import {
  Chip,
  InfoOutlinedIcon,
  Link,
  Popover,
  Stack,
  Typography,
  makeStyles,
} from '@gogame/components';
import { useNumberFormat } from '@gogame/intl-ts';

import { SmartRuleRunResults } from 'scenes/SmartRules/SmartRuleRunResults';

const useStyles = makeStyles((theme) => ({
  root: {
    color: theme.palette.primary.main,
    cursor: 'pointer',
  },
  icon: {
    color: theme.palette.primary.main,
  },
}));
export const ActiveLastRunResults = ({ row, openChildComponent }) => {
  const numberFormatter = useNumberFormat();
  const classes = useStyles();
  const handleClickEntities = React.useCallback(() => {
    openChildComponent(SmartRuleRunResults, {
      id: row.id,
    });
  }, [row.id, openChildComponent]);

  const isPopover =
    row.action &&
    (!isNil(row.modifyFailedEntitiesCount) ||
      !isNil(row.modifySkippedEntitiesCount) ||
      !isNil(row.modifiedEntitiesCount));

  const ChipComponent = !isNil(row.affectedEntitiesCount) ? (
    <Chip
      label={`${numberFormatter(row.affectedEntitiesCount)} entities`}
      variant={'outlined'}
      icon={isPopover ? <InfoOutlinedIcon /> : null}
      classes={classes}
    />
  ) : null;

  return (
    <React.Fragment>
      {!isNil(row.affectedEntitiesCount) ? (
        row.affectedEntitiesCount > 0 ? (
          <Link onClick={handleClickEntities}>
            {isPopover ? (
              <Popover
                hover={true}
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'right',
                }}
                transformOrigin={{
                  vertical: 'bottom',
                  horizontal: 'left',
                }}
                anchor={ChipComponent}
                PaperProps={{
                  style: {
                    width: '154px',
                  },
                }}
              >
                <Stack spacing={1} style={{ padding: 16 }}>
                  <Stack direction={'row'} justifyContent={'space-between'}>
                    {!isNil(row.modifiedEntitiesCount) ? (
                      <React.Fragment>
                        <Typography color={'textSecondary'}>
                          Modified
                        </Typography>
                        <Typography variant={'body2'}>
                          {numberFormatter(row.modifiedEntitiesCount)}
                        </Typography>
                      </React.Fragment>
                    ) : null}
                  </Stack>
                  <Stack direction={'row'} justifyContent={'space-between'}>
                    {!isNil(row.modifySkippedEntitiesCount) ? (
                      <React.Fragment>
                        <Typography color={'textSecondary'}>
                          Skipped{' '}
                        </Typography>
                        <Typography variant={'body2'}>
                          {numberFormatter(row.modifySkippedEntitiesCount)}
                        </Typography>
                      </React.Fragment>
                    ) : null}
                  </Stack>
                  <Stack direction={'row'} justifyContent={'space-between'}>
                    {!isNil(row.modifyFailedEntitiesCount) ? (
                      <React.Fragment>
                        <Typography color={'textSecondary'}>Failed </Typography>
                        <Typography variant={'body2'}>
                          {numberFormatter(row.modifyFailedEntitiesCount)}
                        </Typography>
                      </React.Fragment>
                    ) : null}
                  </Stack>
                </Stack>
              </Popover>
            ) : (
              ChipComponent
            )}
          </Link>
        ) : (
          <Chip label={'No matches'} variant={'outlined'} />
        )
      ) : null}
    </React.Fragment>
  );
};
